(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordions"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function ($) {
    let count = 1;
    $('.accordion__category').each(function () {
      var accID = $(this).find('.anchor').attr('id');
      var accName = $(this).find('> .heading').text();
      var active = '';
      if (count == 1) {
        active = 'btn--active';
      }

      $('.faqs__nav').append(
        '<a href="#' + accID + '" class="btn btn--sm btn--round ' + active + '">' + accName + '</a>'
      );
      $('.faqs__nav select').append('<option value="#' + accID + '">' + accName + '</option>');
      count++;
    });

    $('body').on('change', '.faqs__nav select', function () {
      var accID = $(this).val();

      $('html, body').animate(
        {
          scrollTop: $(accID).offset().top,
        },
        200,
        'linear'
      );
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections-static"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function ($) {
    $('.grow-list__filter button').on('click', function () {
      const filter = $(this).attr('data-filter');

      $('.grow-list__filter button').removeClass('active');
      $(this).addClass('active');

      if (filter == 'all') {
        $('.collections__list .card').removeClass('hidden');
      } else {
        $('.collections__list  .card').each(function () {
          const letter = $(this).attr('data-letter');

          if (letter != filter) {
            $(this).addClass('hidden');
          } else {
            $(this).removeClass('hidden');
          }
        });
      }
    });

    $('.grow-list__filter select').on('change', function () {
      const filter = $(this).val();

      if (filter == 'all') {
        $('.collections__list  .card').removeClass('hidden');
      } else {
        $('.collections__list  .card').each(function () {
          const letter = $(this).attr('data-letter');

          if (letter != filter) {
            $(this).addClass('hidden');
          } else {
            $(this).removeClass('hidden');
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function ($) {
    $('.grow-list__filter button').on('click', function () {
      const filter = $(this).attr('data-filter');

      $('.grow-list__filter button').removeClass('active');
      $(this).addClass('active');

      if (filter == 'all') {
        $('.collections__list .card').removeClass('hidden');
      } else {
        $('.collections__list  .card').each(function () {
          const letter = $(this).attr('data-letter');

          if (letter != filter) {
            $(this).addClass('hidden');
          } else {
            $(this).removeClass('hidden');
          }
        });
      }
    });

    $('.grow-list__filter select').on('change', function () {
      const filter = $(this).val();

      if (filter == 'all') {
        $('.collections__list  .card').removeClass('hidden');
      } else {
        $('.collections__list  .card').each(function () {
          const letter = $(this).attr('data-letter');

          if (letter != filter) {
            $(this).addClass('hidden');
          } else {
            $(this).removeClass('hidden');
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["growing-guide-list"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function ($) {
    $('.grow-list__filter button').on('click', function () {
      const filter = $(this).attr('data-filter');

      $('.grow-list__filter button').removeClass('active');
      $(this).addClass('active');

      if (filter == 'all') {
        $('.grow-list__list .card').removeClass('hidden');
      } else {
        $('.grow-list__list .card').each(function () {
          const letter = $(this).attr('data-letter');

          if (letter != filter) {
            $(this).addClass('hidden');
          } else {
            $(this).removeClass('hidden');
          }
        });
      }
    });

    $('.grow-list__filter select').on('change', function () {
      const filter = $(this).val();

      if (filter == 'all') {
        $('.grow-list__list .card').removeClass('hidden');
      } else {
        $('.grow-list__list .card').each(function () {
          const letter = $(this).attr('data-letter');

          if (letter != filter) {
            $(this).addClass('hidden');
          } else {
            $(this).removeClass('hidden');
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-tabs"] && !Shopify.designMode) return;
  try {
    
  jQuery(document).ready(function ($) {
    function activateTab($newTab) {
      const $tabs = $('.pdp-tabs [role="tab"]');

      $tabs.attr('aria-selected', 'false').attr('tabindex', '-1');
      $('[role="tabpanel"]').attr('aria-hidden', 'true');

      $newTab.attr('aria-selected', 'true').attr('tabindex', '0');
      $('#' + $newTab.attr('aria-controls')).attr('aria-hidden', 'false');
    }

    // Delegate click
    $(document).on('click', '.pdp-tabs [role="tab"]', function () {
      activateTab($(this));
    });

    // Delegate keydown
    $(document).on('keydown', '.pdp-tabs [role="tab"]', function (e) {
      const $tabs = $('.pdp-tabs [role="tab"]');
      const index = $tabs.index(this);
      let newIndex;

      switch (e.key) {
        case 'ArrowLeft':
          newIndex = index > 0 ? index - 1 : $tabs.length - 1;
          break;
        case 'ArrowRight':
          newIndex = (index + 1) % $tabs.length;
          break;
        case 'Home':
          newIndex = 0;
          break;
        case 'End':
          newIndex = $tabs.length - 1;
          break;
        default:
          return; // exit if not a supported key
      }

      e.preventDefault();
      activateTab($tabs.eq(newIndex));
    });

    // Initial tabindex setup for accessibility + auto-select first available
    function setupInitialTabs() {
      const $tabs = $('.pdp-tabs [role="tab"]:visible');

      if ($tabs.length) {
        $tabs.attr('tabindex', '-1');
        $tabs.attr('aria-selected', 'false');

        const $active = $tabs.filter('[aria-selected="true"]');

        if ($active.length) {
          $active.attr('tabindex', '0');
        } else {
          // If no active tab, pick the first visible one
          activateTab($tabs.first());
        }
      }
    }

    setupInitialTabs();
  });

  } catch(e) { console.error(e); }
})();
})();
